import { useMembers } from "@/queries/organization-queries";
import type { PlainMessage } from "@bufbuild/protobuf";
import type { OrganizationMember } from "gitpod-next-api/gitpod/v1/organization_pb";

export function useMember(userId?: string): {
    member?: PlainMessage<OrganizationMember>;
    isPending: boolean;
    error: Error | null;
} {
    const { data: membersData, isPending: isPendingMembers, error: membersError } = useMembers();

    return {
        member: membersData?.members.find((m) => m.userId === userId),
        isPending: isPendingMembers,
        error: membersError,
    };
}
